<template>
  <a-modal
    title="修改"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 密码 -->
      <a-form-item label="喜欢" 
        :labelCol="{lg: {span: 7}}"
        :wrapperCol="{lg: {span: 13}}"
        >
        <a-input type="password" 
          placeholder="请输入"  
          v-decorator="['likeNumber', {rules: [{ required: true, message: '请输入' }], validateTrigger: 'change'}]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import school from '../../api/school'
import course from '../../api/course'
export default {
  name: 'personFormModal',
  data(){
    return{
      form: this.$form.createForm(this),
      visible: false,
     courseId: 0,
     courseName: '',
     likeNumber: 0,
     intro: '',
     params:"",
      confirmLoading: false,
    }
  },
  methods:{
    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

    init(params){
      this.visible = true;
      this.courseId = params.id;
    },

    //提交操作
    handleSubmit(e){
      e.preventDefault();
      let self = this;
      this.$confirm({
        title: `确定要修改吗?`,
        okText: "确定",
        cancelText: "取消",
        content: "修改后，无法撤销",
        onOk() {
          self.form.validateFields((err, value) => {
            if (!err) {
              self.update(value.password)
            }
          })
        }
      });
      
    },

    //重置密码
    update(password){
      let req = {
        id: this.courseId,
		likeNumber:likeNumber,
      }
      course.updateRecommend(req).then(res=>{
        this.$message.success('修改密码成功')
        this.handleCancel();
      })
    }
  },
  created(){
  }


}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
  .cl-inner{
    width: calc(100% - 40px);
    padding: 50px 20px 30px;
    background: white;
    margin: 20px auto;
  }
  .ap-form{
    width: 400px;
  }
  .form-oper{
    text-align: center;
    button{
      margin: 0px 5px;
    }
  }
</style>